import { render, staticRenderFns } from "./getWordRhyme.vue?vue&type=template&id=10c325c7&"
import script from "./getWordRhyme.vue?vue&type=script&lang=js&"
export * from "./getWordRhyme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports